import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCliente } from "../context/ClienteContext";
import axios from "axios";
import "../styles/CadastroUsuario.css";
import "../styles/global.css";

const CadastroTurma = () => {
  const navigate = useNavigate();
  const { parametros } = useCliente();
  const [formData, setFormData] = useState({
    codigo: "",
    nome: "",
    curso_id: "",
    data_inicio: "",
    data_termino: ""
  });
  const [cursos, setCursos] = useState([]);
  const [coordenadores, setCoordenadores] = useState([]);
  const [errors, setErrors] = useState({});
  const [sucesso, setSucesso] = useState(false);
  const [cursoSelecionado, setCursoSelecionado] = useState("");

  const [filtroCodigo, setFiltroCodigo] = useState("");
  const [filtroNome, setFiltroNome] = useState("");
  const [filtroNivel, setFiltroNivel] = useState("");
  const [filtroModalidade, setFiltroModalidade] = useState("");
  const [filtroCoordenador, setFiltroCoordenador] = useState("");

  useEffect(() => {
    const fetchCursosECoordenadores = async () => {
      try {
        const clienteId = localStorage.getItem("cliente_id");

        const [cursosResponse, coordenadoresResponse] = await Promise.all([
          axios.get(`/api/cursos?cliente_id=${clienteId}`),
          axios.get(`/api/usuarios/coordenadores?cliente_id=${clienteId}`)
        ]);

        if (Array.isArray(cursosResponse.data)) {
          const cursosOrdenados = cursosResponse.data.sort((a, b) => a.nome.localeCompare(b.nome));
          setCursos(cursosOrdenados);
        }

        if (Array.isArray(coordenadoresResponse.data)) {
          const coordenadoresOrdenados = coordenadoresResponse.data.sort((a, b) => a.nome_completo.localeCompare(b.nome_completo));
          setCoordenadores(coordenadoresOrdenados);
        }

      } catch (error) {
        console.error("Erro ao carregar cursos ou coordenadores:", error);
      }
    };

    fetchCursosECoordenadores();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleCursoSelect = (e) => {
    setCursoSelecionado(e.target.value);
    setFormData((prev) => ({ ...prev, curso_id: e.target.value }));
    setErrors((prev) => ({ ...prev, curso_id: "" }));
  };

  const validarFormulario = () => {
    const novosErros = {};

    if (!formData.codigo.trim()) novosErros.codigo = "Código obrigatório.";
    if (!formData.nome.trim()) novosErros.nome = "Nome obrigatório.";
    if (!formData.curso_id) novosErros.curso_id = "Selecione um curso.";
    if (!formData.data_inicio) novosErros.data_inicio = "Data de início obrigatória.";
    if (!formData.data_termino) novosErros.data_termino = "Data de término obrigatória.";

    if (formData.data_inicio && formData.data_termino) {
      const inicio = new Date(formData.data_inicio);
      const termino = new Date(formData.data_termino);
      if (termino < inicio) {
        novosErros.data_termino = "Data de término não pode ser anterior à data de início.";
      }
    }

    setErrors(novosErros);
    return Object.keys(novosErros).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validarFormulario()) return;

    try {
      const clienteId = localStorage.getItem("cliente_id");
      const payload = {
        ...formData,
        cliente_id: clienteId,
        usuario_id: parseInt(localStorage.getItem("user_id"), 10)
      };
    

      const response = await fetch("/api/turmas/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        setSucesso(true);
        setTimeout(() => {
          setSucesso(false);
          navigate("/turmas");
        }, 4000);
      } else {
        const data = await response.json();
        alert(data.erro || "Erro ao cadastrar turma.");
      }
    } catch (error) {
      console.error("Erro de conexão:", error);
      alert("Erro de conexão com o servidor.");
    }
  };

  const renderErro = (campo) => errors[campo] && <span className="campo-erro">{errors[campo]}</span>;

  const cursosFiltrados = cursos.filter((curso) => {
    const codigoOk = curso.codigo?.toLowerCase().includes(filtroCodigo.toLowerCase());
    const nomeOk = curso.nome?.toLowerCase().includes(filtroNome.toLowerCase());
    const nivelOk = filtroNivel ? curso.nivel === filtroNivel : true;
    const modalidadeOk = filtroModalidade ? curso.modalidade === filtroModalidade : true;
    const coordenadorOk = filtroCoordenador ? curso.coordenador_nome === filtroCoordenador : true;
    return codigoOk && nomeOk && nivelOk && modalidadeOk && coordenadorOk;
  });

  return (
    <div className="form-wrapper form-coordenador">
      <h2 className="form-title">Cadastro de Turma</h2>
      <form onSubmit={handleSubmit} noValidate>
        {sucesso && <div className="sucesso-msg">Turma cadastrada com sucesso!</div>}

        {/* Código + Nome */}
        <div className="form-row">
          <div className={`form-group ${errors.codigo ? 'erro' : ''}`} style={{ width: '220px', flex: 'none' }}>
            <label>Código da Turma</label>
            <input type="text" name="codigo" value={formData.codigo} onChange={handleChange} />
            {renderErro("codigo")}
          </div>
          <div className={`form-group ${errors.nome ? 'erro' : ''}`} style={{ flex: 1 }}>
            <label>Nome da Turma</label>
            <input type="text" name="nome" value={formData.nome} onChange={handleChange} />
            {renderErro("nome")}
          </div>
        </div>

        {/* Datas */}
        <div className="form-row">
          <div className={`form-group ${errors.data_inicio ? 'erro' : ''}`} style={{ width: '220px', flex: 'none' }}>
            <label>Data de Início</label>
            <input type="date" name="data_inicio" value={formData.data_inicio} onChange={handleChange} max="9999-12-31" />
            {renderErro("data_inicio")}
          </div>
          <div className={`form-group ${errors.data_termino ? 'erro' : ''}`} style={{ width: '220px', flex: 'none' }}>
            <label>Data de Término</label>
            <input type="date" name="data_termino" value={formData.data_termino} onChange={handleChange} max="9999-12-31" />
            {renderErro("data_termino")}
          </div>
        </div>

        {/* Linha divisória */}
        <hr style={{ borderTop: "3px solid #007BFF", margin: "20px 0" }} />

        {/* Filtros */}
        <div className="filtros-cursos">
          <div className="filtros-linha-1">
            <input
              type="text"
              value={filtroCodigo}
              onChange={(e) => setFiltroCodigo(e.target.value)}
              placeholder="Filtrar código"
              style={{ width: "80px" }}
            />
            <input
              type="text"
              value={filtroNome}
              onChange={(e) => setFiltroNome(e.target.value)}
              placeholder="Filtrar nome"
            />
            <select value={filtroNivel} onChange={(e) => setFiltroNivel(e.target.value)}>
              <option value="">nível</option>
              <option value="Ensino Médio">Ensino Médio</option>
              <option value="Preparatório">Preparatório</option>
              <option value="Graduação/Pós">Graduação/Pós</option>
              <option value="PJ RH/T&D">PJ RH/T&D</option>
            </select>
            <select value={filtroModalidade} onChange={(e) => setFiltroModalidade(e.target.value)}>
              <option value="">modalidade</option>
              <option value="Presencial">Presencial</option>
              <option value="Híbrido">Híbrido</option>
              <option value="Live">Live</option>
              <option value="EAD">EAD</option>
              <option value="Outros">Outros</option>
            </select>
            <select value={filtroCoordenador} onChange={(e) => setFiltroCoordenador(e.target.value)}>
              <option value="">coordenador</option>
              {coordenadores.map((coord) => (
                <option key={coord.id} value={coord.nome_completo}>
                  {coord.nome_completo}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Tabela de Cursos */}
        <div className="table-wrapper">
          <table className="tabela">
            <thead style={{ backgroundColor: parametros?.cor_cabecalho || "#156082", color: "white" }}>
              <tr>
                <th style={{ width: "5%" }}>Selecionar</th>
                <th style={{ width: "20%" }}>Cód. Curso</th>
                <th style={{ width: "45%" }}>Nome do Curso</th>
                <th style={{ width: "30%" }}>Coordenador</th>
              </tr>
            </thead>
            <tbody>
              {cursosFiltrados.map((curso) => (
                <tr key={curso.id}>
                  <td>
                    <input
                      type="radio"
                      name="curso_id"
                      value={curso.id}
                      checked={cursoSelecionado === String(curso.id)}
                      onChange={handleCursoSelect}
                    />
                  </td>
                  <td>{curso.codigo}</td>
                  <td>{curso.nome}</td>
                  <td>{curso.coordenador_nome}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {renderErro("curso_id")}
        </div>

        {/* Botões */}
        <div className="form-actions">
          <button type="button" className="btn btn-secondary" onClick={() => navigate(-1)}>
            Cancelar
          </button>
          <button type="submit" className="btn btn-primary">
            Salvar
          </button>
        </div>
      </form>
    </div>
  );
};

export default CadastroTurma;
